import { utils, writeFile } from "sheetjs-style";

const createCell = () => {

}

export const GenerateHRXLSX = (header, data, options) => {
        
    const ws = utils.json_to_sheet(data, { origin: 9 });
    const wb = utils.book_new();
    utils.sheet_add_aoa(ws, [
        [, 
            {
                v: "TIMESHEET",
                t: "s",
                s: { 
                    font: {
                        bold: true
                    },
                    alignment: { 
                        horizontal: "center"
                    },
                    border: {
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }
        ],
        [, 
            {
                v: "Accurately record & check time in and time out for every shift on a daily basis. Employees should sign and submit Time Record to Immediate head.",
                t: "s",
                s: {
                    font: {
                        sz: 7,
                        italic: true
                    }
                }
            }
        ],
        [,  
            {
                v: "Submit all Time Records to HR on the time and date designated for the pay period.",
                t: "s",
                s: {
                    font: {
                        sz: 7,
                        italic: true
                    }
                }
            }
        ],
        [,  
            {
                v: "NOTE: Falsification of Time Records constitutes fraud and is a serious violation of Company Policy.",
                t: "s",
                s: {
                    font: {
                        sz: 7,
                        italic: true
                    }
                }
            }
        ],
        [,  
            {
                v: "To ensure correct pay data, please fill-up all boxes.",
                t: "s",
                s: {
                    font: {
                        sz: 7,
                        italic: true,
                        color: { rgb: "FFFF0000" }
                    }
                }
            }
        ],
        [, 
            {
                v: "PayPeriod",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: header.payperiod,
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "Payroll Date",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: header.payrolldate,
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }
        ],
        [,  
            {
                v: "Employee ID",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: header.employeeid,
                t: "n",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "Company",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "BAYVIEW",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }
        ],
        [, 
            {
                v: "Employee Name",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: header.name,
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "Department",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "MSW",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }
        ],
        [, 
            {
                v: "",
                s: {
                    border: {
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "Unit/Group",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: header.department,
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: true
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }
        ],
      ], { origin: 0 });
    utils.book_append_sheet(wb, ws, header.name);

    // // cell layout
    ws["B10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["C10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["D10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["E10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["F10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }


    // merge cells
    // s = start, r = row, c=col, e= end
    const merge = [
        { s: { r: 0, c: 1 }, e: { r: 0, c: 5 } },
        { s: { r: 1, c: 1 }, e: { r: 1, c: 5 } },
        { s: { r: 2, c: 1 }, e: { r: 2, c: 5 } },
        { s: { r: 3, c: 1 }, e: { r: 3, c: 5 } },
        { s: { r: 4, c: 1 }, e: { r: 4, c: 5 } },
        { s: { r: 5, c: 2 }, e: { r: 5, c: 3 } },
        { s: { r: 7, c: 1 }, e: { r: 8, c: 1 } },
        { s: { r: 7, c: 2 }, e: { r: 8, c: 3 } },
        { s: { r: options.endrow, c: 1 }, e: { r: options.endrow, c: 4 } },
        { s: { r: (options.endrow + 1), c: 2 }, e: { r: (options.endrow + 1), c: 5 } }
      ];
      ws["!merges"] = merge;


    // cells width in pixels
    var wscols = [
        {wpx: 50},
        {wpx: 180},
        {wpx: 130},
        {wpx: 100},
        {wpx: 100},
        {wpx: 130}
    ];
    ws['!cols'] = wscols;
    


    // cells height
    var wsrows = []
    for (let x = 0; x < (options.endrow + 2); x++) {
        if (x === 1 || x === 2 || x === 3 || x === 4) wsrows.push({hpx: 16})
        else if (x === options.endrow) wsrows.push({hpx: 23})
        else if (x === (options.endrow + 1)) wsrows.push({hpx: 30})
        else wsrows.push({hpx: 20})  
    }
    ws['!rows'] = wsrows;

    ws['!protect'] = {
        password: 'rtyitpd'
    }


    writeFile(wb, `Timesheet - ${header.name} (${header.payperiod}).xlsx`);
}




export const GenerateInternalXLSX = (header, data, options) => {

    const ws = utils.json_to_sheet(data, { origin: 9 });
    const wb = utils.book_new();
    utils.sheet_add_aoa(ws, [
        [, 
            {
                v: "TIMESHEET",
                t: "s",
                s: { 
                    font: {
                        bold: true
                    },
                    alignment: { 
                        horizontal: "center"
                    },
                    border: {
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }
        ],
        [, 
            {
                v: "Accurately record & check time in and time out for every shift on a daily basis. Employees should sign and submit Time Record to Immediate head.",
                t: "s",
                s: {
                    font: {
                        sz: 7,
                        italic: true
                    }
                }
            }
        ],
        [,  
            {
                v: "Submit all Time Records to HR on the time and date designated for the pay period.",
                t: "s",
                s: {
                    font: {
                        sz: 7,
                        italic: true
                    }
                }
            }
        ],
        [,  
            {
                v: "NOTE: Falsification of Time Records constitutes fraud and is a serious violation of Company Policy.",
                t: "s",
                s: {
                    font: {
                        sz: 7,
                        italic: true
                    }
                }
            }
        ],
        [,  
            {
                v: "To ensure correct pay data, please fill-up all boxes.",
                t: "s",
                s: {
                    font: {
                        sz: 7,
                        italic: true,
                        color: { rgb: "FFFF0000" }
                    }
                }
            }
        ],
        [, 
            {
                v: "PayPeriod",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: header.payperiod,
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "Payroll Date",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: header.payrolldate,
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }
        ],
        [,  
            {
                v: "Employee ID",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: header.employeeid,
                t: "n",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "Company",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "BAYVIEW",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }
        ],
        [, 
            {
                v: "Employee Name",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: header.name,
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "Department",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "MSW",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }
        ],
        [, 
            {
                v: "",
                s: {
                    border: {
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "Unit/Group",
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center"
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: header.department,
                t: "s",
                s: {
                    font: {
                        sz: 10,
                        bold: true
                    },
                    alignment: {
                        vertical: "center",
                        horizontal: "center",
                        wrapText: true
                    },
                    border: {
                        top: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        left: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    } 
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }, {
                v: "",
                s: {
                    border: {
                        bottom: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        },
                        right: {
                            style: "thick",
                            color: { rgb: "00000000" }
                        }
                    }
                }
            }
        ],
      ], { origin: 0 });
    utils.book_append_sheet(wb, ws, header.name);

    // // cell layout
    ws["B10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["C10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["D10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["E10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["F10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["G10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["H10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["I10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["J10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["K10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["L10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }
    ws["M10"].s = {
        font: {
            sz: 8
        },
        alignment: {
            vertical: "center",
            horizontal: "center"
        },
        border: {
            top: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            left: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            bottom: {
                style: "thick",
                color: { rgb: "00000000" }
            },
            right: {
                style: "thick",
                color: { rgb: "00000000" }
            }
        }
    }


    // merge cells
    // s = start, r = row, c=col, e= end
    const merge = [
        { s: { r: 0, c: 1 }, e: { r: 0, c: 12 } },
        { s: { r: 1, c: 1 }, e: { r: 1, c: 12 } },
        { s: { r: 2, c: 1 }, e: { r: 2, c: 12 } },
        { s: { r: 3, c: 1 }, e: { r: 3, c: 12 } },
        { s: { r: 4, c: 1 }, e: { r: 4, c: 12 } },
        { s: { r: 5, c: 1 }, e: { r: 5, c: 3 } },
        { s: { r: 5, c: 4 }, e: { r: 5, c: 6 } },
        { s: { r: 5, c: 7 }, e: { r: 5, c: 9 } },
        { s: { r: 5, c: 10 }, e: { r: 5, c: 12 } },
        { s: { r: 6, c: 1 }, e: { r: 6, c: 3 } },
        { s: { r: 6, c: 4 }, e: { r: 6, c: 6 } },
        { s: { r: 6, c: 7 }, e: { r: 6, c: 9 } },
        { s: { r: 6, c: 10 }, e: { r: 6, c: 12 } },
        { s: { r: 7, c: 1 }, e: { r: 8, c: 3 } },
        { s: { r: 7, c: 4 }, e: { r: 8, c: 6 } },
        { s: { r: 7, c: 7 }, e: { r: 7, c: 9 } },
        { s: { r: 7, c: 10 }, e: { r: 7, c: 12 } },
        { s: { r: 8, c: 7 }, e: { r: 8, c: 9 } },
        { s: { r: 8, c: 10 }, e: { r: 8, c: 12 } },
        { s: { r: options.endrow, c: 1 }, e: { r: options.endrow, c: 4 } },
        { s: { r: options.endrow, c: 6 }, e: { r: options.endrow, c: 7 } },
        { s: { r: options.endrow, c: 9 }, e: { r: options.endrow, c: 12 } },
        { s: { r: (options.endrow + 1), c: 2 }, e: { r: (options.endrow + 1), c: 12 } }
      ];
      ws["!merges"] = merge;


    // cells width in pixels
    var wscols = [
        {wpx: 50},
        {wpx: 180},
        {wpx: 130},
        {wpx: 70},
        {wpx: 70},
        {wpx: 70},
        {wpx: 70},
        {wpx: 70},
        {wpx: 70},
        {wpx: 70},
        {wpx: 70},
        {wpx: 70},
        {wpx: 70}
    ];
    ws['!cols'] = wscols;


    // cells height
    var wsrows = []
    for (let x = 0; x < (options.endrow + 2); x++) {
        if (x === 1 || x === 2 || x === 3 || x === 4) wsrows.push({hpx: 16})
        else if (x === options.endrow) wsrows.push({hpx: 23})
        else if (x === (options.endrow + 1)) wsrows.push({hpx: 30})
        else wsrows.push({hpx: 20})  
    }
    ws['!rows'] = wsrows;

    ws['!protect'] = {
        password: 'rtyitpd'
    }


    writeFile(wb, `Timesheet[Internal] - ${header.name} (${header.payperiod}).xlsx`);

}